import React from 'react';

/**
 * Unapproved organizations (requests) columns.
 * Matches backend payload fields (PascalCase), while the service also provides aliases.
 */
export const UnapprovedDataColumns = ({
  MultiViewCalenderFilterCell,
  dateRangeFilter,
  GridDateCell,
  setDateRangeFilter,
  GridFlag,
  BooleanFlagFilterCell,
}) => {
  const dataColumns = [
    // Keep org id hidden but usable for actions
    {
      field: 'organization_id',
      title: 'organization_id',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 150,
      filterable: false,
      excludeFromFilter: true,
    },
    {
      field: 'Id',
      title: 'Id',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 150,
      filterable: false,
      excludeFromFilter: true,
    },
    {
      field: 'Name',
      title: 'Name',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'Domain',
      title: 'Domain',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 150,
    },
    {
      field: 'Description',
      title: 'Description',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 150,
    },
    {
      field: 'Active',
      title: 'Active',
      editable: false,
      show: true,
      width: '120px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanFlagFilterCell,
    },
    {
      field: 'IsApproved',
      title: 'Is Approved',
      editable: false,
      show: true,
      width: '140px',
      minResizableWidth: 80,
      // This is nullable (pending). Not adding BooleanFlagFilterCell because values are null/true/false.
      // Keep as plain text for now.
    },
    {
      field: 'RequestedBy',
      title: 'Requested By',
      editable: false,
      show: true,
      width: '240px',
      minResizableWidth: 120,
    },
    {
      field: 'RequestedSource',
      title: 'Requested Source',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 100,
    },
    {
      field: 'CreatedBy',
      title: 'Created By',
      editable: false,
      show: true,
      width: '240px',
      minResizableWidth: 120,
    },
    {
      field: 'Created_Date',
      title: 'Created Date',
      editable: false,
      show: true,
      width: '220px',
      minResizableWidth: 120,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'Created_Date',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
    {
      field: 'ModifiedBy',
      title: 'Modified By',
      editable: false,
      show: true,
      width: '240px',
      minResizableWidth: 120,
    },
    {
      field: 'ModifiedDate',
      title: 'Modified Date',
      editable: false,
      show: true,
      width: '220px',
      minResizableWidth: 120,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'ModifiedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
    {
      field: 'ApprovedBy',
      title: 'Approved By',
      editable: false,
      show: true,
      width: '240px',
      minResizableWidth: 120,
    },
    {
      field: 'ApprovedDate',
      title: 'Approved Date',
      editable: false,
      show: true,
      width: '220px',
      minResizableWidth: 120,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'ApprovedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
    {
      field: 'RejectionReason',
      title: 'Rejection Reason',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 150,
    },
  ];

  return dataColumns;
};

export default UnapprovedDataColumns;